import { useState } from 'react'
import { cancelAtendimento, loginByToken } from '../core/_requests'
import { useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import {
  ButtonType,
  IconPaths,
  IconSize,
  KTSVG,
  MaskType,
  MotivoCancelamentoAtendimentoType,
  OptionsHelper,
  showAlert,
  showError,
} from '../../../../_metronic/helpers'
import {
  Button,
  ContactSupportLink,
  FormInput,
  FormSelect,
  FormTextArea,
  IOption,
  LoadingIndicator,
} from '../../../components'
import { TokenDtoAtendimento } from '../core/_models'
import { setTeleAuth } from '../core/teleConsultaAuth'
import { cancelarSchema } from './validation/cancelarSchema'
import styles from './styles/CancelarTeleConsulta.module.css'

export const CancelarTeleConsulta = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { protocolo } = useParams()

  const formik = useFormik({
    initialValues: {
      numeroDocumento: '',
      motivo: undefined as IOption<string> | undefined,
      motivoDetalhado: '',
    },
    validationSchema: cancelarSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setIsLoading(true)
      if (protocolo) {
        try {
          const digits = values.numeroDocumento.replace(/\D/g, '')
          const token: TokenDtoAtendimento = {
            cpf: digits.length === 11 ? values.numeroDocumento : undefined,
            cns: digits.length === 15 ? values.numeroDocumento : undefined,
            protocolo,
          }
          const data = await loginByToken(token)
          if (data && data.accessToken) {
            setTeleAuth(data)
          } else {
            console.error('Erro: Token inválido.')
          }
          // Cancelar não é consentir: este fluxo não registra aceite do termo. O endpoint de
          // cancelamento (DELETE /public/paciente/atendimento/{protocolo}) não exige aceite.
          // Código e detalhamento vão separados: a classificação do motivo é do servidor.
          const motivoCodigo = values.motivo?.value as string
          const motivoDetalhe =
            motivoCodigo === MotivoCancelamentoAtendimentoType.Outros
              ? values.motivoDetalhado.trim()
              : undefined

          await cancelAtendimento(protocolo, motivoCodigo, motivoDetalhe)
          showAlert({
            title: 'Sucesso',
            text: 'Atendimento cancelado com sucesso!',
            icon: 'success',
          })
        } catch (error) {
          showError(error)
        } finally {
          setIsLoading(false)
          setSubmitting(false)
        }
      }
    },
  })

  const isOutros = formik.values.motivo?.value === MotivoCancelamentoAtendimentoType.Outros

  return (
    <div className='container d-flex flex-column justify-content-center align-items-center flex-grow-1'>
      <div
        className='d-flex flex-column bg-gray-200 rounded-4 w-100 p-4 p-md-5'
        style={{ maxWidth: '620px' }}
      >
        <div className={styles.badgeWrap} aria-hidden='true'>
          <span className={styles.ring} />
          <span className={styles.badge}>
            <KTSVG path={IconPaths.X} size={IconSize.Medium} />
          </span>
        </div>

        <div className='text-center mb-8'>
          <h1 className='text-dark mb-2 fs-2x'>Cancelar Teleconsulta</h1>
          <p className='text-gray-700 fs-6 mb-0'>
            Confirme seus dados e o motivo para cancelar este atendimento
          </p>
        </div>

        <form onSubmit={formik.handleSubmit} noValidate>
          <FormInput
            formik={formik}
            label='CPF ou CNS'
            name='numeroDocumento'
            placeholder='Digite seu CPF ou CNS'
            mask={MaskType.CpfCns}
            className='mb-6'
            isRequired
          />

          <div className='mb-6'>
            <FormSelect
              formik={formik}
              name='motivo'
              entity='motivo_cancelamento'
              fetchOptions={OptionsHelper.getOptionsMotivosNaoRealizacao}
              isDisabled={formik.isSubmitting}
              isRequired
            />
          </div>

          {isOutros && (
            <div className='mb-6'>
              <FormTextArea
                formik={formik}
                name='motivoDetalhado'
                entity='detalhes_cancelamento'
                isDisabled={formik.isSubmitting}
                rows={3}
                isRequired
              />
            </div>
          )}

          <Button
            type={ButtonType.Submit}
            className='btn-danger btn-auth-full mt-6'
            disabled={isLoading || formik.isSubmitting}
            icon={isLoading ? undefined : IconPaths.X}
            iconSize={IconSize.Small}
          >
            {isLoading ? <LoadingIndicator /> : 'Cancelar Atendimento'}
          </Button>

          <div className='text-center mt-4'>
            <ContactSupportLink message='Precisa de ajuda? Fale com o suporte.' />
          </div>
        </form>
      </div>
    </div>
  )
}
